import React, { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext({ breadcrumbs: null, setBreadcrumbs: () => {} });

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbs, _setBreadcrumbs] = useState(null);
  const setBreadcrumbs = useCallback((crumbs) => _setBreadcrumbs(crumbs), []);

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = () => useContext(BreadcrumbContext);
